import {
  GroupVisitSessionControllerApi,
  UpdateSessionStatusSessionStatusEnum,
} from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  sessionId: string;
  sessionStatus: UpdateSessionStatusSessionStatusEnum;
};

export const useUpdateGroupSessionStatus = () =>
  useMutationWithLoading(async ({ sessionId, sessionStatus }: Params) =>
    new GroupVisitSessionControllerApi(getConfigObject()).updateSessionStatus(
      sessionId,
      sessionStatus,
      getXtenantId()
    )
  );
